import clsx from "clsx";
import Select from "./Select";
import Label from "./Label";
import LabelSelectStyle from "./css/LabelSelect.module.css";
import { ReactNode } from "react";
import Text from "./Text";

type SelectOption = {
    text: string;
    value: string;
    default?: boolean;
}

type LabelSelectProps = {
    label?: ReactNode;
    id?: string;
    required?: boolean;
    direction?: "top" | "left";
    options: SelectOption[];
    onChange?: (value: string) => void;
    name: string;
    fullWidth?: boolean;
    disabled?: boolean;
    className?: string;
}

function LabelSelect({ 
    label, 
    id, 
    direction = "top", 
    required = false, 
    options,
    onChange,
    name,
    disabled,
    className,
    fullWidth,
    ...props 
}: LabelSelectProps) {
    const _label = label ?? <Text size={direction === "top" ? "sm" : "md"}>라벨</Text>;
    
    return (
        <div 
            className={clsx(
                LabelSelectStyle['label-select-container'],
                LabelSelectStyle[`label-select-container-${direction}`]
            )}
            style={{
                width: fullWidth ? "100%" : undefined,
            }}
        >
            <Label required={required} htmlFor={id}>{_label}</Label>
            <Select
                id={id}
                options={options}
                onChange={onChange}
                name={name}
                fullWidth
                disabled={disabled}
                className={className}
                {...props}
            />
        </div>
    );
}

export default LabelSelect;
export type { SelectOption };

